import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import LogBase from "./_LogBase.vue";

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const columns = [
  { prop: "logdate", label: "Огноо" },
  { prop: "username", label: "Хэрэглэгч" },
  { prop: "orgcode", label: "Байгууллага" },
  { prop: "method", label: "Method" },
  { prop: "url_path", label: "URL" },
  { prop: "ex_class", label: "Exception" },
  { prop: "ex_message", label: "Мессеж" },
  { prop: "client_ip", label: "IP" }
];

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(LogBase, {
    title: "Алдааны лог",
    endpoint: "/logs/error",
    columns: columns,
    show: { org: true, ip: true, method: true }
  }))
}
}

})